import React from 'react';
import { Button } from 'semantic-ui-react';
import { CartPropType } from '../../../services/proptypes';
import OloCheckout from '../../OloCheckout';
var MenuCartDisplayTotal = function MenuCartDisplayTotal(_ref) {
  var total = _ref.total,
    onCheckout = _ref.onCheckout,
    cart = _ref.cart,
    locationId = _ref.locationId,
    isOpen = _ref.isOpen,
    totalTitle = _ref.totalTitle;
  return /*#__PURE__*/React.createElement("div", {
    className: "menu-cart-total"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h4", null, totalTitle), /*#__PURE__*/React.createElement("h4", null, "$", total.toFixed(2))), /*#__PURE__*/React.createElement(OloCheckout, {
    trigger: /*#__PURE__*/React.createElement(Button, {
      primary: true,
      fluid: true,
      onClick: onCheckout,
      disabled: total === 0 || !isOpen
    }, isOpen ? 'Checkout' : 'Ordering Closed'),
    cart: cart,
    locationId: locationId
  }));
};
MenuCartDisplayTotal.defaultProps = {
  isOpen: false,
  totalTitle: 'Subtotal'
};
export default MenuCartDisplayTotal;